import * as React from "react"
import type { SVGProps } from "react"
const SvgDrop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 21q-3.32 0-5.66-2.3A7.6 7.6 0 0 1 4 13.1q0-1.62.63-3.04a8 8 0 0 1 1.72-2.51l4.6-4.53a2 2 0 0 1 .5-.3q.27-.12.55-.12.27 0 .55.11.27.12.5.31l4.6 4.53a8 8 0 0 1 1.73 2.51q.62 1.42.62 3.04 0 3.3-2.34 5.6A7.8 7.8 0 0 1 12 21m-5.95-7H17.9q.3-1.8-.34-3.07A7 7 0 0 0 16.25 9L12 4.8 7.75 9q-.68.65-1.32 1.93A5 5 0 0 0 6.05 14" />
  </svg>
)
export default SvgDrop
